import React from "react";
import appService from "../../../services/app.service";
import { DetailsOverview } from "../base/DetailsOverview";
import { useTranslation } from "react-i18next";
import { NoAdminAlert } from "../../NoAdminAlert"

export const TerminationOverview: React.FunctionComponent<{ isAdmin: boolean }> = (props) => {
    const { t } = useTranslation();
    const detailsRedirection = "/config/terminations/details";
    const title = t("client:headers:tabTerminations");
    const { isAdmin } = props;

    if (isAdmin !== true) { return <NoAdminAlert /> }

    return (
        <DetailsOverview detailsRedirection={detailsRedirection} getItems={appService.getTerminations} entityType="terminations" title={title}></DetailsOverview>
    );
};
